import { withForm } from '@/core/form/withForm';
import BaseSelect from '@/components/atoms/Select';

export const Select = withForm(BaseSelect);
